import { getSearchParamsString } from '@reapitform/utils'
import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { IPaginationParams, IResponseWithPagination } from '../../types'
import { useMemo } from 'react'
import { IDefaultLink } from '../../types/default-link'
import { useQueryClient } from '@tanstack/react-query'

export const useDefaultsLink = (params: IPaginationParams) => {
  const queryClient = useQueryClient()

  const searchParams = getSearchParamsString(params)
  const path: string = `/api/Organization/DefaultLink${searchParams}`
  const [result, loading, errorString] = usePlatformGet<IResponseWithPagination<IDefaultLink>>({
    path,
    retry: false,
  })

  const queryKey = useMemo(getUrl(path), [path])

  const { _embedded, ...pagination } = result ?? {}

  const updateCacheData = (data: IDefaultLink[] | ((preData: IDefaultLink[]) => IDefaultLink[])) => {
    if (!queryClient) return

    queryClient.setQueryData([queryKey], (prevData: IResponseWithPagination<IDefaultLink>) => {
      let newValue = data
      if (typeof data === 'function') newValue = data(prevData._embedded)

      return { ...prevData, _embedded: newValue }
    })

    queryClient.invalidateQueries({ queryKey: [queryKey] })
  }

  return { data: _embedded, pagination: pagination, loading, errorString, updateCacheData }
}
